<template>
  <empty-state-card
    v-if="notValidContractMessage"
    icon="close"
    :message="notValidContractMessage"
  ></empty-state-card>
  <div v-else>
    <banner
      v-if="!mobile"
      :bannerDefaultImgs="config.images.bannerDefault"
      :bannerDefaultTitle="getBannerTitle"
      :bannerDefaultDescription="bannerText"
    ></banner>
    <screen-loading v-if="loadingApp" />
    <div v-else class="change-repeated-email">
      <p>{{ upperText }}</p>
      <steps v-model="selectedStep" :steps="enums.changeRepeatedEmailSteps">
        <template v-slot:[stepName]>
          <v-card>
            <div class="pa-3">
              <div>{{ user.fullName }}</div>
              <radio-details
                detailSelectionOnly
                :options="radioOptions"
                v-model="emailValidationMode"
                @change="emailValidationMode_changed"
              >
                <!-- <template v-if="stepName == 'step1'"></template> -->
                <template #details0>
                  <!--//? Confirm email mode -->
                  <div class="mb-4">
                    <v-form
                      class="pt-2"
                      @submit.prevent="submitEmailValidation"
                      ref="changeEmailForm"
                      v-model="changeEmailFormValid"
                      lazy-validation
                    >
                      <v-layout
                        justify-space-between
                        v-if="stepName == 'step1'"
                      >
                        <v-btn
                          type="submit"
                          class="success--background white--text"
                          >{{ $t('actions.send') }}</v-btn
                        >
                        <v-spacer />
                      </v-layout>
                    </v-form>
                    <div v-if="stepName == 'step2'">
                      <v-form
                        class="pt-2"
                        @submit.prevent="submitVerificationCode"
                        ref="confirmEmailForm"
                        v-model="confirmEmailFormValid"
                        lazy-validation
                      >
                        <span>{{ emailSentMessage }}</span>
                        <text-field
                          :label="$t('pages.profile.validationCode')"
                          v-model="verificationCode"
                          :rules="rule.verificationCode"
                          :error-messages="error.temporaryPassword"
                          required
                        ></text-field>
                        <v-layout
                          :column="mobile"
                          :justify-space-around="!mobile"
                          :align-center="mobile"
                        >
                          <v-btn
                            @click="submitEmailValidation"
                            class="support--background white--text"
                          >
                            <v-progress-circular
                              color="white"
                              indeterminate
                              v-if="loadingApp"
                            ></v-progress-circular>
                            <span v-else>{{
                              $t('pages.profile.resendEmailConfirmation')
                            }}</span>
                          </v-btn>
                          <v-btn
                            :disabled="!confirmEmailFormValid"
                            type="submit"
                            class="success--background white--text"
                          >
                            <v-progress-circular
                              color="white"
                              indeterminate
                              v-if="loadingApp"
                            ></v-progress-circular>
                            <span v-else>{{ 'Verificar código' }}</span>
                          </v-btn>
                          <v-spacer />
                        </v-layout>
                      </v-form>
                    </div>
                  </div>
                </template>
                <template #details1>
                  <!--//?  Change email mode -->
                  <div v-if="stepName == 'step1'" class="mb-4 content">
                    <v-form
                      class="pt-2"
                      @submit.prevent="submitEmailValidation"
                      ref="changeEmailForm"
                      v-model="changeEmailFormValid"
                      lazy-validation
                    >
                      <v-layout row wrap>
                        <v-flex xs8 md4 lg4>
                          <text-field
                            label="E-mail"
                            type="email"
                            v-model="newEmail"
                            :rules="rule.requiredEmail"
                            required
                          ></text-field>
                        </v-flex>
                        <v-flex xs8 md4 lg4 class="field-spacing">
                          <text-field
                            :label="$t('pages.profile.confirmEmail')"
                            type="email"
                            v-model="confirmEmail"
                            :rules="confirmEmailRules"
                            required
                          ></text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout
                        :column="mobile"
                        :justify-space-around="!mobile"
                        :align-center="mobile"
                      >
                        <v-btn
                          type="submit"
                          class="success--background white--text btn-md"
                        >
                          <v-progress-circular
                            color="white"
                            indeterminate
                            v-if="loadingApp"
                          ></v-progress-circular>
                          <span v-else>{{ $t('labels.save') }}</span>
                        </v-btn>
                        <v-spacer />
                      </v-layout>
                    </v-form>
                  </div>
                  <div v-if="stepName == 'step2'">
                    <v-form
                      class="pt-2"
                      @submit.prevent="submitVerificationCode"
                      ref="confirmEmailForm"
                      v-model="confirmEmailFormValid"
                      lazy-validation
                    >
                      <span>{{ emailSentMessage }}</span>
                      <text-field
                        :label="$t('pages.profile.validationCode')"
                        v-model="verificationCode"
                        :rules="rule.verificationCode"
                        required
                      ></text-field>
                      <v-layout
                        :column="mobile"
                        :justify-space-around="!mobile"
                        :align-center="mobile"
                      >
                        <v-btn
                          @click="submitEmailValidation"
                          class="support--background white--text"
                        >
                          <v-progress-circular
                            color="white"
                            indeterminate
                            v-if="loadingApp"
                          ></v-progress-circular>
                          <span v-else>{{
                            $t('pages.profile.resendEmailConfirmation')
                          }}</span>
                        </v-btn>
                        <v-btn
                          :disabled="!confirmEmailFormValid"
                          type="submit"
                          class="success--background white--text"
                        >
                          <v-progress-circular
                            color="white"
                            indeterminate
                            v-if="loadingApp"
                          ></v-progress-circular>
                          <span v-else>{{
                            $t('pages.profile.password.verifyCode')
                          }}</span>
                        </v-btn>
                        <v-spacer />
                      </v-layout>
                    </v-form>
                  </div>
                </template>
              </radio-details>
            </div>
          </v-card>
        </template>
        <template #step3>
          <v-card class="pa-5 mb-2">
            <v-card-text class="text-md-center font-weight-bold">{{
              $t('pages.profile.updateSuccessMessage')
            }}</v-card-text>
          </v-card>
          <v-layout justify-end>
            <v-btn
              v-if="userIsVerified"
              @click="goToSelectUnit"
              class="success--background white--text"
            >
              <v-progress-circular
                color="white"
                indeterminate
                v-if="loadingApp"
              ></v-progress-circular>
              <span v-else>{{ $t('pages.profile.login') }}</span>
            </v-btn>
            <v-btn
              v-else
              @click="goToCreateLogin"
              class="success--background white--text"
            >
              <v-progress-circular
                color="white"
                indeterminate
                v-if="loadingApp"
              ></v-progress-circular>
              <span v-else>{{ $t('pages.profile.createLogin') }}</span>
            </v-btn>
          </v-layout>
        </template>
      </steps>
    </div>
  </div>
</template>

<script>
import AuthContainer from '@/components/auth/Container';
import TextField from '@/components/fields/TextField';
import profileMixin from '../../mixins/modules/profile';
import bus from '../../utils/bus';
import enums from '@/utils/enums';
import { setDuplicatedEmail, logout, setAccessType } from '../../services/auth';
import { USER, UNIT, CONFIG, ROLES } from '../../utils/constants';
import supportMixin from '../../mixins/modules/support';
import Banner from '@/components/Banner';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import EmptyStateCard from '@/components/layout/EmptyStateCard';
import Steps from '@/components/layout/Steps';
import RadioDetails from '@/components/layout/RadioDetails';

export default {
  name: 'changeRepeatedEmail',
  mixins: [profileMixin, supportMixin],
  components: {
    AuthContainer,
    TextField,
    Banner,
    ScreenLoading,
    EmptyStateCard,
    Steps,
    RadioDetails,
  },
  computed: {
    config() {
      return this.$store.getters[CONFIG.GET];
    },
    confirmEmailRules() {
      return [
        ...this.rule.requiredEmail,
        (v) =>
          v == this.newEmail ||
          this.$t('pages.profile.emailsDoesNotMatchError'),
      ];
    },
    userIsVerified() {
      return this.user.verified;
    },
    stepName() {
      return 'step' + (this.selectedStep + 1);
    },
    isVerificationCodeValid() {
      return this.verificationCode.length == 6;
    },
    emailSentMessage() {
      const email =
        this.emailValidationMode === this.changeEmailOption
          ? this.newEmail
          : this.user.email;
      return this.$t('pages.profile.emailSentMessage', [email]);
    },
    radioOptions() {
      return [
        {
          value: this.confirmEmailOption,
          text: this.$t('pages.profile.confirmEmailAddress', [this.user.email]),
          visible: !this.user.email.includes('@temporario.com'),
        },
        {
          value: this.changeEmailOption,
          text: this.$t('pages.profile.editEmailLabel'),
          visible: true,
        },
      ];
    },
    getBannerTitle() {
      var config = this.config;
      return this.$store.getters[UNIT.GET_IS_SYNDIC]
        ? config.texts.syndicBannerTitle
        : config.texts.bannerTitle;
    },
  },

  data() {
    return {
      selectedStep: -1,
      emailValidationMode: '',
      confirmEmailOption: 'confirmEmail',
      changeEmailOption: 'changeEmail',
      upperText: '',
      bannerText: '',
      notValidContractMessage: '',
      confirmEmailFormValid: true,
      changeEmailFormValid: true,
      error: {
        emails: '',
      },
      username: '',
      userRole: ROLES.CLIENT_ROLE,
      showUsernameField: '',
      updatingEmail: false,
      newEmail: '',
      confirmEmail: '',
      currentEmail: '',
      verificationCode: '',
      model: {
        client: {
          email: '',
        },
      },
    };
  },
  created() {
    this.userRole = this.$router.currentRoute.meta.userRole;
    this.$router.replace(this.$router.currentRoute.path);
    this._getUser();
    // this.getTicketCrmToken(this.$store.getters[UNIT.GET_ALL][0]);
    setAccessType(enums.accessTypes.repeatedEmail);
  },
  methods: {
    emailValidationMode_changed(value) {
      this.emailValidationMode = value;
      if (value) {
        this.selectedStep = 0;
      } else {
        this.selectedStep = -1;
      }
    },
    updateEmail(v) {
      if (!this.updatingEmail) {
        this.updatingEmail = true;
      }
      this.model.client.email = v;
    },
    emailsCheck() {
      if (!this.updatingEmail || this.model.client.email == this.confirmEmail)
        return true;
      this.error.emails = this.$t('pages.profile.emailsDoesNotMatchError');
      return false;
    },
    async _getUser() {
      try {
        this.loading = true;
        await Promise.all([this.getUser()]);
        const data = this.$store.getters[USER.GET_IMOBME_DATA];
        this.model.client = Object.assign(this.model.client, data);
        this.currentEmail = this.model.client.email;
        this.model.client.email = '';
      } finally {
        this.loading = false;
      }
    },
    displayNoUsernameErrorMessage() {
      bus.$emit('snackbar:open', {
        text: this.$t('pages.profile.invalidEmail'),
        color: 'error',
        multiLine: true,
      });
    },

    displayVerificationCodeError() {
      bus.$emit('snackbar:open', {
        text: this.$t('pages.profile.password.invalidCode'),
        color: 'error',
        multiLine: true,
      });
    },
    goToSelectUnit() {
      setAccessType(enums.accessTypes.login);
      this.createTrace(this.enums.logTraceActions.login);
      this.$router.push({ name: 'selectUnit' });
    },

    goToCreateLogin() {
      this.createTrace(this.enums.logTraceActions.logout);
      logout();
    },

    async submitEmailValidation() {
      if (!this.$refs.changeEmailForm.validate()) {
        return;
      }
      console.warn('submitEmailValidation');

      const emailValidationBody = {
        username: this.user.username,
        userRole: this.user.userRole,
      };
      if (this.emailValidationMode === this.changeEmailOption) {
        emailValidationBody.email = this.newEmail;
      } else if (this.emailValidationMode === this.confirmEmailOption) {
        emailValidationBody.email = this.user.email;
      }
      console.log('emailValidationBody', emailValidationBody);

      const emailValidationUrl = `${process.env.AUTH_API_URL}/emailValidation`;
      const emailValidationResult = await this.requestService(
        emailValidationUrl,
        'POST',
        {
          data: emailValidationBody,
          localErrorHandling: false,
        }
      );

      if (
        emailValidationResult.message ==
        this.$t('pages.profile.emailConfirmationSentMessage')
      ) {
        this.selectedStep = 1;
      }
    },
    async submitVerificationCode() {
      try {
        console.log(this.$refs);
        if (!this.$refs.confirmEmailForm.validate()) {
          return;
        }
        console.warn('submitVerificationCode');
        const emailConfirmationBody = {
          username: this.user.username,
          userRole: this.user.userRole,
          confirmationCode: this.verificationCode,
        };

        console.log('emailConfirmationBody', emailConfirmationBody);

        const emailConfirmationUrl = `${process.env.AUTH_API_URL}/emailConfirmation`;
        const emailConfirmationResult = await this.requestService(
          emailConfirmationUrl,
          'POST',
          {
            data: emailConfirmationBody,
            localErrorHandling: true,
          }
        );

        if (
          emailConfirmationResult.message ==
          this.$t('pages.profile.emailConfimedMessage')
        ) {
          this.selectedStep = 2;
          this.$store.commit(USER.MUTATE_USER, {
            ...this.user,
            ...emailConfirmationResult.user,
          });
          setDuplicatedEmail(false);
          bus.$emit('snackbar:open', {
            text: this.$t('pages.profile.updateSuccessMessage'),
            color: 'green',
          });
        }
      } catch (error) {
        this.displayVerificationCodeError();
      } finally {
        this.loadingForm = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';

.change-repeated-email {
  width: 75%;
  margin: 0 auto;
  .field-spacing {
    @include breakpoint(not-mobile) {
      padding-left: 8px !important;
    }

    @include breakpoint(mobile) {
      padding-left: 0px !important;
    }
  }
  // &__go-back {
  //   color: var(--label-color) !important;
  //   font-weight: 400;
  // }

  // .v-card {
  //   max-height: 486px;
  // }

  // .v-btn {
  //   min-width: 50px;
  //   @include breakpoint(not-mobile) {
  //     margin: 0;
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// src/views/auth/ChangeRepeatedEmail.vue